export const data = {
    experience: [
      {
        title: "IT/Software Analyst - Blackmore Partners",
        subTitle: "Chicago, IL",
        description:
          "For a majority of the time, I Implemented a Flask based Rest API using Python that aimed to improve the interface that internal and external executives utilized during client meetings. This would allow information and data relating to company finances, employee scheduling, and private equity to be shared/presented in a more proffesional and seamless manor. Other than that, I worked on updating/fixing the company website using WordPress, led company onboardings for new hires, and participated in code reviews for new and pre-existing code for the company",
          date:"May 2022 - Aug 2022",
        },
      {
        title: "Software Engineering Intern - Adient",
        subTitle: "Plymouth, MI",
        description:
          "As an intern at Adient, I developed and depolyed multiple software applications involving SQL and JavaScript that aim to integrate and convert files from one place to another. This allows file integration from various plants across the world to be mitigated under a single query that was eventually pushed to production. This allows for changes and file conversions as well as specific attribue projections for each process to be completed much more efficiently and under the same query.",
          date:"May 2023 - Aug 2023",
        },
    ],
    education: [
      {
        title: "Northville High School",
        subTitle: "Northville, MI",
        description:
          "Track & Field Captain, Drumline Captain, DECA, HOSA",
          date:"Sep 2017 - May 2021",
        },
      {
        title: "University of Michigan ",
        subTitle: "Ann Arbor, MI",
        description:
          "Bachelor's of Science Majoring in Computer Science",
          date:"Aug 2021 - PRESENT",
      },
    ],
  };